import React, { useEffect, useRef } from 'react';
import { ArrowLeftRight } from 'lucide-react';
import dropPickPlannerTestData from './data/dropPickPlannerTestData';
import { LiveUnloadPlannerCard } from '@/components/AutobookPlanner';
import { usePlannerFilteredList } from './usePlannerFilteredList';
import styles from './plannerPage.module.css';

const PAGE_SIZE = 5;
const MOCK_API_MS = 450;

export function fetchDropPickPlannerPageMock(
  offset,
  limit,
  pool = dropPickPlannerTestData
) {
  return new Promise((resolve) => {
    setTimeout(() => {
      const items = pool.slice(offset, offset + limit);
      resolve({ items, total: pool.length });
    }, MOCK_API_MS);
  });
}

export function DropPickPlannerTab({ distanceLimitMi, containerSearch }) {
  const { items, loadingMore, hasMore, loadNextPageRef, filteredTotal } =
    usePlannerFilteredList({
      source: dropPickPlannerTestData,
      distanceLimitMi,
      containerSearch,
      pageSize: PAGE_SIZE,
      mockMs: MOCK_API_MS,
    });

  const sentinelRef = useRef(null);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0]?.isIntersecting) return;
        const load = loadNextPageRef.current;
        if (typeof load === 'function') load();
      },
      { root: null, rootMargin: '160px 0px', threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={styles.liveUnloadSection}>
      <div className={styles.liveUnloadHeader}>
        <ArrowLeftRight
          className={styles.liveUnloadClock}
          size={24}
          strokeWidth={2}
          color="#131517"
          aria-hidden
        />
        <div>
          <h2 className={styles.liveUnloadTitle}>Drop / Pick Planner</h2>
          <p className={styles.liveUnloadSubtitle}>
            Timeline now uses buffer time instead of unloading time.
          </p>
        </div>
      </div>

      <div
        className={styles.liveUnloadList}
        role="feed"
        aria-busy={loadingMore}
        aria-label="Drop and pick timeline cards">
        {filteredTotal === 0 && !loadingMore ? (
          <p className={styles.liveUnloadEnd}>
            No containers match your filters.
          </p>
        ) : (
          <>
            {items.map((card) => (
              <LiveUnloadPlannerCard key={card.id} card={card} />
            ))}
            {loadingMore ? (
              <p className={styles.liveUnloadLoading}>Loading…</p>
            ) : null}
            {/* {!hasMore && items.length > 0 ? (
              <p className={styles.liveUnloadEnd}>End of list</p>
            ) : null} */}
            <div
              ref={sentinelRef}
              className={styles.liveUnloadSentinel}
              aria-hidden
            />
          </>
        )}
      </div>
    </div>
  );
}
